import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthService } from "../auth.service";
import { DataServiceService } from "../data-service.service";
import { Company } from "../model/Company";
import { CreditHistory, User } from "../model/login";

@Component({
  selector: "app-new-user",
  templateUrl: "./new-user.component.html",
  styleUrls: ["./new-user.component.scss"],
})
export class NewUserComponent implements OnInit {
  creditInfo: CreditHistory = {
    entitled: 0,
    available: 0,
    editedBy: "",
    note: "",
  }
  isLoading: boolean = true;
  newUser: User = {
    userId: "",
    companyId: "",
    userName: "",
    email: "",
    password: "",
    totalCreditsEntitled: undefined,
    usedCredits: undefined,
    startDate: new Date(),
    endDate: new Date(),
    status: "",
    statusRemarks: "",
    userType: "",
    lastLogin: undefined,
    user: "",
    phoneNumber: "",
    companyDetails: [],
    creditHistory: []
  };

  availableCompanies = [];
  selectedCompany: Company = {
    companyId: "-9999",
    companyName: "Select Company",
    userCount: 0,
    companyEmail: "",
    companyType: "",
    clientNumber: "",
    registeredAddress: "",
    registrationNumber: "",
    contractSignDate: undefined,
    status: "",
    statusRemarks: ""
  };

  constructor(private modalService: NgbModal, private dataService: DataServiceService, private router: Router, private authService: AuthService) {}

  ngOnInit(): void {
    this.getAllCompanies()
    .then(() => {
      this.isLoading = false;
    })
  }

  invalidUser() {
    if (this.newUser.user.trim() == "") return true;
    else return false;
  }

  invalidUname() {
    if (this.newUser.userName.trim() == "") return true;
    else return false;
  }

  invalidEmail() {
    if (
      !this.validateEmail(this.newUser.email) ||
      this.newUser.email.trim() == ""
    )
      return true;
    else return false;
  }

  invalidPNum() {
    if (!this.validatePhone(this.newUser.phoneNumber)) return true;
    if (
      (this.newUser.phoneNumber + "").trim() == "" ||
      this.newUser.phoneNumber.length <= 6
    ) {
      return true;
    } else return false;
  }

  invalidCompany() {
    if (
      this.selectedCompany.companyId == "-9999" &&
      this.selectedCompany.companyName == "Select Company"
    ) {
      return true;
    } else {
      return false;
    }
  }

  invalidPassword() {
    if (!this.validatePassword(this.newUser.password)) return true;
    if ((this.newUser.password + "").trim() == "") {
      return true;
    } else return false;
  }

  invalidCredits(){
    if(this.newUser.totalCreditsEntitled < 0){
      return true;
    }
    else {
      return false;
    }
  }

  invalidDates() {
    const sDate: Date = new Date(this.newUser.startDate)
    const eDate: Date = new Date(this.newUser.endDate)
    if(sDate > eDate){
      return true;
    }
    else{
      return false;
    }
  }

  invalidForm() {
    return (
      this.invalidCredits() ||
      this.invalidDates() ||
      this.invalidCompany() ||
      this.invalidUname() ||
      this.invalidEmail() ||
      this.invalidPNum() ||
      this.invalidPassword()
    );
  }

  selectCompany(company) {
    this.selectedCompany = company;
  }

  validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  validatePhone = (phone) => {
    return String(phone)
      .toLowerCase()
      .match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/);
  };

  validatePassword = (password) => {
    return String(password).match(
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/gm
    );
  };

  async getAllCompanies(){
    this.availableCompanies = await this.dataService.getAllCompanies()
  }

  submitForm(){
    this.newUser.companyId = this.selectedCompany.companyId;
    this.newUser.status = 'Inforce';
    this.newUser.userType = 'USER';
    this.newUser.isAdverseMediaEnabled = false;
    this.creditInfo.entitled = this.newUser.totalCreditsEntitled
    this.creditInfo.available = this.newUser.totalCreditsEntitled
    this.creditInfo.editedBy = this.authService.getCurrentUser().userName
    this.creditInfo.note = `New User added with ${this.creditInfo.entitled} credits.`
    this.newUser.creditHistory.push(this.creditInfo)
    this.dataService.addUser(this.newUser)
    .then(() => {
      const but = document.getElementById("successBtn") as HTMLButtonElement;
      but.click();
      setTimeout(() => {
        this.modalService.dismissAll()
        this.router.navigate(['/all-users'])
      }, 3000);
    })
    .catch(() => {
      const but = document.getElementById("failBtn") as HTMLButtonElement;
      but.click();
    });
  }

  openSuccessPopup(smallModalContent) {
    this.modalService.open(smallModalContent, { size: "sm" });
  }

  openFailPopup(smallModalContent2) {
    this.modalService.open(smallModalContent2, { size: "sm" });
  }
}
